import React from "react";
import { Routes, Route, Private } from "components/Routing";

import Evaluations from "./scenes/Evaluations";
import EvaluationList from "./scenes/Evaluations/scenes/List";
import EvaluationForm from "./scenes/Evaluations/scenes/Form";
import TriggerEvaluations from "./scenes/Evaluations/scenes/Trigger";
import ProceduresList from "./scenes/ProcedureEvaluations/scenes/List";
import ProceduresForm from "./scenes/ProcedureEvaluations/scenes/Form";
import LogProcedureEvaluations from "./scenes/ProcedureEvaluations/scenes/Log/LogProcedureEvaluations";
import ProcedureEvaluations from "./scenes/ProcedureEvaluations/index";

export const EvaluationsRouting = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Private component={Evaluations} />}>
          <Route path="/" element={<EvaluationList />} />
          <Route path="form/:id" element={<EvaluationForm />} />
          <Route path="trigger" element={<TriggerEvaluations />} />          
        </Route>
      </Routes>
    </>
  );
};

export const ProcedureEvaluationsRouting = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Private component={ProcedureEvaluations} />}>
          <Route path="/" element={<ProceduresList />} />
          <Route path="form/:id" element={<ProceduresForm />} />
          <Route path="log" element={<LogProcedureEvaluations />} />
        </Route>
      </Routes>
    </>
  );
};
